import { useEffect, type ReactNode } from 'react';
import { Typography } from '@tempmee/react';
import {
  Box,
  Column,
  FloatingContainer,
  Row,
  Screen,
  Stepper,
  ZStack,
} from '~/commonComponents';
import { BackButtonProxy as BackButton } from '~/commonComponents/BackButton';

const SHIFT_REQUEST_STEPS = ['Select Dates', 'Shift Details', 'Add Invites', 'Review & Confirm'];

interface IShiftRequestHeaderProps {
  currentStep: number;
  onBack?: () => void;
  backUrl?: string;
  maxWidth?: number;
  children: ReactNode;
}

export const ShiftRequestHeader = ({
  currentStep,
  onBack,
  backUrl,
  maxWidth,
  children,
}: IShiftRequestHeaderProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen minWidth={768} paddingInline={30} paddingTop={16} paddingBottom={16}>
      <FloatingContainer
        justifyContent="flex-start"
        maxWidth={maxWidth}
        borderRadius={0}
        margin={0}
        minWidth={0}
        width="100%"
        alignSelf="center"
        height="100%"
      >
        <Row alignItems="center" marginTop={60} position="relative">
          <ZStack left={20}>
            <BackButton onClick={onBack} url={backUrl} />
          </ZStack>
          <Typography as="span" bold size="heading_3" textAlign="center" style={{ flex: 1 }}>
            Shift Request
          </Typography>
        </Row>
        <Column paddingHorizontal={28} paddingTop={24} paddingBottom={60}>
          <Box maxWidth={700} margin="0 auto 32px" width="100%">
            <Stepper steps={SHIFT_REQUEST_STEPS} currentStep={currentStep} />
          </Box>
          {children}
        </Column>
      </FloatingContainer>
    </Screen>
  );
};
